import React from 'react';
import { Box, Stack, Typography, Grid } from '@mui/material';
import Image, { StaticImageData } from 'next/image';

interface Props {
  name: string;
  sku?: string;
  image: StaticImageData;
}

export const ProductStackItem: React.FC<Props> = props => {
  return (
    <Box mb={4}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={3}
          sx={{
            backgroundColor: 'tertiary.lgray',
            padding: '.5rem',
            '& img': { width: '100%', height: 'auto' },
          }}
        >
          <Image src={props.image} alt={props.name} />
        </Grid>
        <Grid item xs={9}>
          <Stack>
            <Typography
              variant={'h5'}
              sx={{
                fontSize: '.75rem',
                color: 'secondary.dark',
              }}
            >
              {props.name}
            </Typography>
            <Typography
              sx={{
                fontSize: '.75rem',
                color: 'secondary.gray',
                textTransform: 'uppercase',
              }}
            >
              {props.sku}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};
